import PropTypes from 'prop-types';
const SVGComponent =({ fill = '#FAFAFA', ...props })  => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4029_26651"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect x={0.5} width={16} height={16} fill={fill} />
    </mask>
    <g mask="url(#mask0_4029_26651)">
      <mask
        id="mask1_4029_26651"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={16}
        height={16}
      >
        <rect width={16} height={16} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_4029_26651)">
        <path
          d="M10.4 14C10.23 14 10.0875 13.9452 9.9725 13.8357C9.8575 13.7262 9.8 13.5905 9.8 13.4286C9.8 13.2667 9.8575 13.131 9.9725 13.0214C10.0875 12.9119 10.23 12.8571 10.4 12.8571H12.2V12.2857H10.4C10.23 12.2857 10.0875 12.231 9.9725 12.1214C9.8575 12.0119 9.8 11.8762 9.8 11.7143C9.8 11.5524 9.8575 11.4167 9.9725 11.3071C10.0875 11.1976 10.23 11.1429 10.4 11.1429H12.2V10.5714H10.4C10.23 10.5714 10.0875 10.5167 9.9725 10.4071C9.8575 10.2976 9.8 10.1619 9.8 10C9.8 9.8381 9.8575 9.70238 9.9725 9.59286C10.0875 9.48333 10.23 9.42857 10.4 9.42857H12.2V8.85714H10.4C10.23 8.85714 10.0875 8.80238 9.9725 8.69286C9.8575 8.58333 9.8 8.44762 9.8 8.28571C9.8 8.12381 9.8575 7.9881 9.9725 7.87857C10.0875 7.76905 10.23 7.71429 10.4 7.71429H12.2V7.14286H10.4C10.23 7.14286 10.0875 7.0881 9.9725 6.97857C9.8575 6.86905 9.8 6.73333 9.8 6.57143C9.8 6.40952 9.8575 6.27381 9.9725 6.16429C10.0875 6.05476 10.23 6 10.4 6H12.2V5.42857H10.4C10.23 5.42857 10.0875 5.37381 9.9725 5.26429C9.8575 5.15476 9.8 5.01905 9.8 4.85714C9.8 4.69524 9.8575 4.55952 9.9725 4.45C10.0875 4.34048 10.23 4.28571 10.4 4.28571H12.8C13.13 4.28571 13.4125 4.39762 13.6475 4.62143C13.8825 4.84524 14 5.11429 14 5.42857V12.8571C14 13.1714 13.8825 13.4405 13.6475 13.6643C13.4125 13.8881 13.13 14 12.8 14H10.4ZM5.6 9.42857C6.26 9.42857 6.825 9.11905 7.295 8.5C7.765 7.88095 8 7.14286 8 6.28571C8 5.42857 7.765 4.69048 7.295 4.07143C6.825 3.45238 6.26 3.14286 5.6 3.14286C4.94 3.14286 4.375 3.45238 3.905 4.07143C3.435 4.69048 3.2 5.42857 3.2 6.28571C3.2 7.14286 3.435 7.88095 3.905 8.5C4.375 9.11905 4.94 9.42857 5.6 9.42857ZM5.6 14C5.12 14 4.725 13.831 4.415 13.4929C4.105 13.1548 3.985 12.7571 4.055 12.3L4.295 10.2857C3.615 9.97143 3.0625 9.45476 2.6375 8.73571C2.2125 8.01667 2 7.2 2 6.28571C2 5.09524 2.35 4.08333 3.05 3.25C3.75 2.41667 4.6 2 5.6 2C6.6 2 7.45 2.41667 8.15 3.25C8.85 4.08333 9.2 5.09524 9.2 6.28571C9.2 7.2 8.9875 8.01667 8.5625 8.73571C8.1375 9.45476 7.585 9.97143 6.905 10.2857L7.145 12.3C7.215 12.7571 7.095 13.1548 6.785 13.4929C6.475 13.831 6.08 14 5.6 14Z"
          fill={fill}
        />
      </g>
    </g>
  </svg>
);

SVGComponent.propTypes = {
  fill: PropTypes.string,
};


export default SVGComponent;
